var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.toggle()}}},[_vm._t("title")],2),(this.opened === undefined && _vm.internalOpen || this.opened !== undefined && _vm.openedSync)?_c('div',[_vm._t("content")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }